export default "__VITE_ASSET__BMMPa0oq__"